import { render, staticRenderFns } from "./FormContatoEmpresa.vue?vue&type=template&id=b4367956&scoped=true&"
import script from "./FormContatoEmpresa.vue?vue&type=script&lang=js&"
export * from "./FormContatoEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./FormContatoEmpresa.vue?vue&type=style&index=0&id=b4367956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4367956",
  null
  
)

export default component.exports